module.exports = __webpack_public_path__ + "img/flehca_bajo_claro.00a8c5a6.svg";